export default __webpack_public_path__ + "static/media/logo.823c1d72.png";